import { MapPin, Calendar, DollarSign, CheckCircle, Bus } from 'lucide-react';

import sprinter from '../images/sprinter.jpeg';
import bus from '../images/bus.jpeg';
import taxi from '../images/taxi.jpeg';

import { transportData } from '../components/TransportData';


export default function Transport({ handleBookNow }) {

  const transport = transportData;

  return (
    <section id="transport" className="py-16 px-4 bg-white">

      <div className="container mx-auto max-w-6xl">


        <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
          Transport Information
        </h2>


        {/* VEHICLE IMAGES */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">

          <img
            src={sprinter}
            alt="V2V 15 seater student transport taxi"
            className="rounded-2xl shadow-xl h-80 w-full object-cover"
          />

          <img
            src={bus}
            alt="V2V student transport bus"
            className="rounded-2xl shadow-xl h-80 w-full object-cover"
          />

          <img
            src={taxi}
            alt="V2V student transport vehicle"
            className="rounded-2xl shadow-xl h-80 w-full object-cover"
          />

        </div>



        <div className="grid md:grid-cols-2 gap-8">


          {/* ROUTE INFORMATION */}
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 p-8 rounded-xl">


            <div className="flex items-center mb-4">

              <MapPin className="w-6 h-6 text-emerald-600 mr-2" />

              <h3 className="text-2xl font-bold text-gray-900">
                Routes
              </h3>

            </div>


            <p className="text-lg text-gray-700 mb-6">
              Main Route:
              <span className="font-bold ml-2">
                {transport.route}
              </span>
            </p>



            <h4 className="font-semibold text-gray-900 mb-3">
              Available Transport:
            </h4>


            <ul className="space-y-2 text-gray-700">

              {transport.pickupTransport?.map((route)=>(

                <li 
                  key={route}
                  className="flex items-center"
                >

                  <CheckCircle 
                    className="w-4 h-4 mr-2 text-emerald-600"
                  />

                  {route}

                </li>

              ))}

            </ul>



            <h4 className="font-semibold text-gray-900 mt-6 mb-3">
              Drop-off Locations:
            </h4>


            <ul className="space-y-2 text-gray-700">

              {transport.dropoffLocations?.map((location)=>(

                <li
                  key={location}
                  className="flex items-center"
                >

                  <CheckCircle
                    className="w-4 h-4 mr-2 text-emerald-600"
                  />

                  {location}

                </li>

              ))}

            </ul>


          </div>






          <div className="space-y-6">



            {/* TRAVEL DATES */}

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-xl">


              <div className="flex items-center mb-4">

                <Calendar className="w-6 h-6 text-blue-600 mr-2"/>

                <h3 className="text-2xl font-bold text-gray-900">
                  Travel Dates
                </h3>

              </div>



              <ul className="space-y-3 text-gray-700">


                {transport.travelDates?.map((date)=>(

                  <li 
                    key={date}
                    className="flex items-center"
                  >

                    <CheckCircle 
                      className="w-5 h-5 mr-2 text-blue-600"
                    />

                    {date}

                  </li>

                ))}


              </ul>


            </div>






            {/* FLEET */}

            <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-8 rounded-xl">


              <div className="flex items-center mb-4">

                <Bus className="w-6 h-6 text-indigo-600 mr-2"/>

                <h3 className="text-2xl font-bold text-gray-900">
                  Available Vehicles
                </h3>

              </div>



              <ul className="space-y-2 text-gray-700">

                {transport.fleet?.map((vehicle)=>(

                  <li
                    key={vehicle}
                    className="flex items-center"
                  >

                    <CheckCircle
                      className="w-5 h-5 mr-2 text-indigo-600"
                    />

                    {vehicle}

                  </li>

                ))}


              </ul>


            </div>








            {/* PRICING */}

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-8 rounded-xl">


              <div className="flex items-center mb-4">

                <DollarSign className="w-6 h-6 text-amber-600 mr-2"/>

                <h3 className="text-2xl font-bold text-gray-900">
                  Pricing
                </h3>

              </div>



              <p className="text-3xl font-bold text-gray-900">

                R{transport.pricing.totalPrice}

                <span className="text-lg font-normal text-gray-600">
                  {" "}per student
                </span>

              </p>

              {Object.entries(transport.pricing.dropoffPrices || {}).map(([town, price]) => (
                <p key={town} className="text-lg text-gray-700 mt-1">
                  {town}: <span className="font-bold">R{price}</span>
                </p>
              ))}



              <p className="text-lg text-gray-700 mt-3">

                Required Deposit:

                <span className="font-bold text-amber-700 ml-2">

                  R{transport.pricing.deposit}

                </span>

              </p>


            </div>







            {/* CONTACT */}

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-8 rounded-xl">


              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Contact Information
              </h3>


              <p className="text-gray-700">
                <strong>WhatsApp:</strong> 
                {" "}
                {transport.contact.displayWhatsapp}
              </p>


              <p className="text-gray-700 mt-2">
                <strong>Email:</strong>
                {" "}
                {transport.contact.email}
              </p>


            </div>







            {/* BANKING */}

            <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-8 rounded-xl">


              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Banking Details
              </h3>


              <p className="text-gray-700">
                <strong>Bank:</strong> {transport.banking.bank}
              </p>


              <p className="text-gray-700">
                <strong>Account Number:</strong> {transport.banking.accountNumber}
              </p>


              <p className="text-gray-700">
                <strong>Account Owner:</strong> {transport.banking.accountOwner}
              </p>


              <p className="text-gray-700">
                <strong>Reference:</strong> {transport.banking.reference}
              </p>



            </div>




          </div>


        </div>


      </div>

    </section>
  );
}